module.exports = __webpack_public_path__ + "static/media/banner.456e9c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner.png
// module id = 29
// module chunks = 0